import { useEffect, useState } from "react";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import LoadingOverlay from "components/shared/LoadingOverlay";

const PDFDocViewer = ({ doc, height = "500px", showToolbar }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    let timeoutId;
    setIsLoading(true);
    setProgress(0);
    setError(null);

    // Simulated progress (UX feedback)
    const interval = setInterval(() => {
      setProgress((prev) => (prev < 90 ? prev + 10 : prev));
    }, 300);

    // Timeout fallback (e.g. stuck rendering)
    timeoutId = setTimeout(() => {
      if (isMounted) {
        setError("PDF generation took too long. Please try again.");
        setIsLoading(false);
        clearInterval(interval);
      }
    }, 20000); // 20s timeout

    pdf(doc)
      .toBlob()
      .then(() => {
        if (!isMounted) return;
        clearInterval(interval);
        clearTimeout(timeoutId);
        setProgress(100);
        setTimeout(() => setIsLoading(false), 300);
      })
      .catch((err) => {
        if (!isMounted) return;
        clearInterval(interval);
        clearTimeout(timeoutId);
        console.error("PDF generation error:", err);
        setError(
          navigator.onLine
            ? "Failed to generate PDF. Please refresh and try again."
            : "You appear to be offline. Please reconnect and try again."
        );
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
      clearInterval(interval);
      clearTimeout(timeoutId);
    };
  }, [doc]);

  if (error) {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
        <p>{error}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: "#93278F",
            color: "#fff",
            border: "none",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <>
      {isLoading && (
        <>
          <div style={{ width: "100%", background: "#eee", borderRadius: "8px" }}>
            <div
              style={{
                width: `${progress}%`,
                height: "4px",
                background: "#93278F",
                borderRadius: "8px",
                transition: "width 0.3s ease",
              }}
            />
          </div>
          <p style={{ textAlign: "center", marginTop: "10px" }}>{progress}%</p>
        </>
      )}
      {!isLoading && (
        <PDFViewer width="100%" showToolbar={showToolbar} height={height}>
          {doc}
        </PDFViewer>
      )}
    </>
  );
};

export default PDFDocViewer;
